import { FC } from "react";
import { capitalizeFirstLetter } from "@/lib/utils/ui";

interface ArgsHeaderProps {
  commandArgs:
    | string
    | number
    | {
        to: string;
        from: string;
      }
    | undefined;
}

const ArgsHeader: FC<ArgsHeaderProps> = ({ commandArgs }) => {
  if (!commandArgs) return null;

  if (
    (typeof commandArgs === "string" || typeof commandArgs === "number") &&
    commandArgs !== ""
  ) {
    return (
      <div className="flex items-center gap-2">
        <div className="font-bold text-[#7C818C]">Command Arguments</div>
        <ul>
          <li className="text-sm">{commandArgs}</li>
        </ul>
      </div>
    );
  }

  if (typeof commandArgs !== "string" && typeof commandArgs === "object") {
    if (Object.keys(commandArgs).length > 0) {
      return (
        <div className="flex items-center gap-2">
          <div className="font-bold text-[#7C818C]">Command Arguments</div>
          <ul className="flex items-center flex-wrap gap-2">
            {Object.entries(commandArgs).map(([key, value]) => {
              if (value !== undefined && value !== "") {
                return (
                  <li
                    className="text-sm"
                    key={key}
                  >
                    {`${capitalizeFirstLetter(key)}: ${value}`}
                  </li>
                );
              }
              return null;
            })}
          </ul>
        </div>
      );
    }
  }

  return null;
};

export default ArgsHeader;
